import numeral from 'numeral';
import { Component } from 'react';

class ExtraBox extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="table-header-subtitle">
                    <div>
                        {t('discover.categories.table.subtitle_1')}{' '}
                        <a
                            className="text-muted"
                            target="_blank"
                            rel="noreferrer"
                            href="https://cloud.google.com/natural-language/docs/categories?hl=en"
                        >
                            {t('discover.categories.table.here')}
                        </a>
                    </div>
                    <div className="mt-10">
                        {t('discover.categories.table.subtitle_2')}
                        <div className="table-header-subtitle-boxes">
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img
                                        src={
                                            this.props.isDark
                                                ? '/static/img/file-05_dark.svg'
                                                : '/static/img/file-05.svg'
                                        }
                                        alt="img"
                                    />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    {t('discover.categories.table.pages_categories')}
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgPages).format('0.0a')}
                                    </div>{' '}
                                </div>
                            </div>
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img
                                        src={
                                            this.props.isDark
                                                ? '/static/img/cursor-box_dark.svg'
                                                : '/static/img/cursor-box.svg'
                                        }
                                        alt="img"
                                    />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    {t('discover.categories.table.ctr')}
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgCTR).format('0.000%')}
                                    </div>{' '}
                                </div>
                            </div>
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img
                                        src={
                                            this.props.isDark
                                                ? '/static/img/file-search_dark.svg'
                                                : '/static/img/file-search.svg'
                                        }
                                        alt="img"
                                    />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    {t('discover.categories.table.impressions_category')}
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgImpressions).format('0.0a')}
                                    </div>{' '}
                                </div>
                            </div>
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img
                                        src={
                                            this.props.isDark
                                                ? '/static/img/cursor-click-01_dark.svg'
                                                : '/static/img/cursor-click-01.svg'
                                        }
                                        alt="img"
                                    />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    {t('discover.categories.table.clicks_category')}
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgClicks).format('0.0a')}
                                    </div>{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraBox;
